import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { SearchFilterFilter } from '@app/search/search-api.model';
import { SearchFilterId } from '@app/search/services/search-filters.service';

@Component({
  selector: 'dgx-search-filter-range-sidebar',
  templateUrl: './search-filter-range-sidebar.component.html',
  styleUrls: ['./search-filter-range-sidebar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchRangeFilterSidebarComponent {
  @Input() public filter: SearchFilterFilter;
  @Input() public isExpanded: boolean = false;
  @Input() public selectedOptionCount: number = 0;

  @Output() public toggleFilter = new EventEmitter<SearchFilterId>();
  @Output() public filtersChanged = new EventEmitter<SearchFilterFilter>();

  public get filterName(): string {
    return this.filter.config.filterGroup;
  }
  public toggleFilterOptions(): void {
    this.toggleFilter.emit(this.filter.id as SearchFilterId);
  }
}
